<template>
    <v-container fluid class="py-0 px-0" ref="container">
        <v-tabs
            ref="tabs"
            active-class="white"
            background-color="grey lighten-3"
            hide-slider
        >
            <v-tab
                :to="{
                    name: 'wo-ready-for-packing',
                }"
            >
                READY FOR PACKING
            </v-tab>
            <v-tab
                :to="{
                    name: 'main-packing',
                }"
            >
                PACKING
            </v-tab>
            <v-tab
                :to="{
                    name: 'pending-packing',
                }"
            >
                PENDING
            </v-tab>

            <v-tab
                :to="{
                    name: 'scheduled-packing',
                }"
            >
                SCHEDUlED
            </v-tab>
            <v-tab
                :to="{
                    name: 'referred-packing',
                }"
            >
                in Delivery
            </v-tab>
            <v-tab
                :to="{
                    name: 'shipped-packing',
                }"
            >
                SHIPPED
            </v-tab>
            <v-tab
                :to="{
                    name: 'completed-packing',
                }"
            >
                COMPLETED
            </v-tab>
            <v-tab
                v-if="readAllWO && readAllPL"
                :to="{
                    name: 'packing-balance',
                }"
            >
                BALANCE
            </v-tab>
        </v-tabs>
        <v-card flat>
            <v-card-text
                class="overflow-y-auto px-4 pt-4"
                :style="{ height: `${height}px` }"
            >
                <router-view />
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import SocketioService from '@/services/websocket/socket.service.js'
import API from '@/services/api'

export default {
    name: 'WorkOrders',
    data: () => ({
        loading: true,
        height: 0,
        companyId: JSON.parse(localStorage.getItem('company')),
        approvedPermission: undefined,
        readAllWO: false,
        readAllPL: false,
    }),
    async mounted() {
        this.onResize()
        const {
            data: { user },
        } = await API.getMyInfo()
        this.approvedPermission = user.permissions.includes('approvedWO')
        this.readAllWO = user.permissions.includes('readAllWO')
        this.readAllPL = user.permissions.includes('readAllPackingLists')
        SocketioService.connect({
            companyId: this.companyId,
        })
    },
    beforeDestroy() {
        SocketioService.leaveRoom(`${this.companyId}-BOM`)
        SocketioService.disconnect()
    },
    methods: {
        onResize() {
            const {
                container: { clientHeight: containerHeight },
                tabs: {
                    $el: { clientHeight: tabsHeight },
                },
            } = this.$refs
            this.height = window.innerHeight - containerHeight - tabsHeight - 25
        },
    },
}
</script>

<style>
.v-data-table {
    border: 1px solid #eeeeee;
}
thead {
    background: #eeeeee;
}
</style>
